import { getAppStore, listEntity, Publisher, UserContext } from '../../../../../@data';
import { PropertyServingConfigs } from '../../../../../@data/store/schema/models/ServingConfigs';

export async function fetchPropertiesServingConfigs(publisher: Publisher, userContext?: UserContext): Promise<PropertyServingConfigs[]> {
  const effectiveUserContext = userContext || getAppStore().userContext;
  const propertiesServingConfigs = await listEntity([publisher], effectiveUserContext, PropertyServingConfigs);
  return propertiesServingConfigs;
}
